import React, { useState, useEffect, useRef } from 'react';
import { Table, Card, Input, Button, Space, } from 'antd';
import { SearchOutlined, } from '@ant-design/icons';
import Highlighter from 'react-highlight-words';
import axios from 'axios';
import * as common from "./Common";
import useInterval from './useInterval';


const WSF = () => {
  useEffect(() => {
  }, [])

  const [responseResult, setResponseResult] = useState([]);
  const [isMobile, setIsMobile] = useState(false);

  const searchInput = useRef(null);
  const [searchText, setSearchText] = React.useState(null);
  const [searchedColumn, setSearchedColumn] = React.useState(null);
  const [state, setState] = useState({ searchText: '', searchedColumn: '' })


  // 타이머에 의해 API데이타 가져오기
  useInterval(() => {
    //console.log("call apis by timer")
    axios.get("/api/v1/wsf").then((response) => {
      //console.log(response.data);
      if (response.data.status === 0) {
      }
      setResponseResult(response.data.data);
    }).catch(function (error) {

      setResponseResult([]);

      if (error.response) {
        // 요청이 전송되었고, 서버는 2xx 외의 상태 코드로 응답했습니다.
        //console.log(error.response.data);
        console.log(error.response.status);
        console.log(error.response.headers);
      } else if (error.request) {
        // 요청이 전송되었지만, 응답이 수신되지 않았습니다. 
        // 'error.request'는 브라우저에서 XMLHtpRequest 인스턴스이고,
        // node.js에서는 http.ClientRequest 인스턴스입니다.
        console.log(error.request);
      } else {
        // 오류가 발생한 요청을 설정하는 동안 문제가 발생했습니다.
        console.log('Error', error.message);
      }
      console.log(error.config);
    });
  }, 30000);

  const getColumnSearchProps = dataIndex => ({
    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
      <div style={{ padding: 8 }}>
        <Input
          ref={searchInput}
          placeholder={`Search ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
          onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
          style={{ width: 188, marginBottom: 8, display: 'block' }}
        />
        <Space>
          <Button
            type="primary"
            onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
            icon={<SearchOutlined />}
            size="small"
            style={{ width: 90 }}
          >
            Search
          </Button>
          <Button onClick={() => handleReset(confirm, clearFilters)} size="small" style={{ width: 90 }}>
            Reset
          </Button>
        </Space>
      </div>
    ),
    filterIcon: filtered => <SearchOutlined style={{ color: filtered ? '#1890ff' : undefined }} />,
    onFilter: (value, record) =>
      record[dataIndex]
        ? record[dataIndex].toString().toLowerCase().includes(value.toLowerCase())
        : '',
      onFilterDropdownOpenChange: visible => {
      if (visible) {
        setTimeout(() => searchInput && searchInput.current && searchInput.current.select()
        )
      }
    },
    render: text =>
      searchedColumn === dataIndex ? (
        <Highlighter
          highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
          searchWords={[searchText]}
          autoEscape
          textToHighlight={text ? text.toString() : ''}
        />
      ) : (
        text
      ),
  });

  const handleSearch = (selectedKeys, confirm, dataIndex) => {
    confirm();
    setState({
      searchText: selectedKeys[0],
      searchedColumn: dataIndex,
    });
  };

  const handleReset = (confirm, clearFilters) => {
    clearFilters();
    setState({ searchText: '' });
    confirm();
  };

  React.useEffect(() => {
    axios.get("/api/v1/wsf").then((response) => {
      //console.log(response.data);
      if (response.data.status === 0) {
      }
      setResponseResult(response.data.data);
    }).catch(function (error) {

      setResponseResult([]);

      if (error.response) {
        // 요청이 전송되었고, 서버는 2xx 외의 상태 코드로 응답했습니다.
        //console.log(error.response.data);
        console.log(error.response.status);
        console.log(error.response.headers);
      } else if (error.request) {
        // 요청이 전송되었지만, 응답이 수신되지 않았습니다. 
        // 'error.request'는 브라우저에서 XMLHtpRequest 인스턴스이고,
        // node.js에서는 http.ClientRequest 인스턴스입니다.
        console.log(error.request);
      } else {
        // 오류가 발생한 요청을 설정하는 동안 문제가 발생했습니다.
        console.log('Error', error.message);
      }
      console.log(error.config);
    });


    const checkIsMobile = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    checkIsMobile(); // 컴포넌트가 마운트되었을 때 한 번 실행
    window.addEventListener('resize', checkIsMobile); // 창 크기가 변경될 때마다 실행
    return () => {
      window.removeEventListener('resize', checkIsMobile); // 컴포넌트가 언마운트될 때 이벤트 리스너 제거
    };
  }, []);

  if (!responseResult) return null;

  // 문자열을 오름차순으로 소팅하는 콜백 함수
  const stringSorter = (val1, val2) => {
    return val1.localeCompare(val2);
  };

  function GoogleMapSearch(loc) {
    const encodedQuery = encodeURIComponent(loc);
    const url = `https://www.google.com/maps/search/?api=1&query=${encodedQuery}`;
    return url;
  }

  const columns = [
    {
      title: "행사명",
      dataIndex: "z_name",
      fixed: "left",
      key: "z_name",
      width: 80,
      ...getColumnSearchProps('z_name'),
      render: (text, record) => <a href={record.z_web} target='_blank' rel='noopener noreferrer nofollow'>{text}</a>
    },
    {
      title: "시작일",
      dataIndex: "z_start",
      key: "z_start",
      width: 30,
      sorter: (a, b) => a.z_start - b.z_start,
      sortDirections: ['descend', 'ascend'],
      render: (text, record) => common.UnixTimeToStringDate(text)
    },
    {
      title: "종료일",
      dataIndex: "z_end",
      width: 30,
      sorter: (a, b) => a.z_end - b.z_end,
      sortDirections: ['descend', 'ascend'],
      render: (text, record) => common.UnixTimeToStringDate(text)
    },
    //{
    //  title: "국가",
    //  dataIndex: "z_country",
    //  width: 20,
    //  sorter: (a, b) => stringSorter(a.z_country, b.z_country),
    //  //filters: common.market_filters,
    //  sortDirections: ['descend', 'ascend']
    //},
    {
      title: "도시",
      dataIndex: "z_city",
      width: 40,
      sorter: (a, b) => stringSorter(a.z_city, b.z_city),
      //filters: common.market_filters,
      sortDirections: ['descend', 'ascend'],
      render: (text, record) => <div><common.ImageDisplay props={record} /> &nbsp;{text} </div>
    },
    {
      title: "장소",
      dataIndex: "z_loc",
      width: 80,
      render: (text, record) => <a href={GoogleMapSearch(record.z_loc)} target='_blank' rel='noopener noreferrer nofollow'>{text}</a>
    },
    {
      title: "장르",
      dataIndex: "z_gnr",
      width: 20,
    },
    {
      title: "비디오ID",
      dataIndex: "z_video",
      width: 40,
      render: (text, record) => {
        const arr_vids = record.z_video.split(',');
        return <>
        {
          arr_vids.map(vid => {
            if(vid) {         
              vid = vid.trim();
              return <a href={`https://www.youtube.com/watch?v=${vid}`} target='_blank' rel='noopener noreferrer nofollow'>&nbsp;{vid}&nbsp;</a>
            }
            return null;
          })
        }
        </>
      }
    },
  ];

  return (
    <div>
      <Card title="World Salsa Festival" size="small" bordered={true}>
        <Table
          bordered
          size="small" scroll={{ x: 1024 }}
          rowKey={common.getUniqueKey}
          dataSource={responseResult}
          columns={columns}
          pagination={{ 
            defaultPageSize: common.DEFAULT_PAGE,
            position: ['None', 'bottomCenter'], 
          }}
        />
      </Card>
    </div>
  )
}

export default WSF;

